import { Controller } from '@hotwired/stimulus'
import Rails from '@rails/ujs'

export default class extends Controller {
  static targets = ['form']

  connect() {
    this.formTarget.addEventListener('change', this.submit.bind(this))
  }

  submit() {
    Rails.fire(this.element, 'submit')
  }
}
